import React from 'react';
import { GridCellParams } from '@mui/x-data-grid';
import { missingField } from 'app/constants';

export const StandardCost = (params: GridCellParams) => {
  return (
    <div>
      <span> {params?.row?.standardCost === missingField ? missingField : `$${params?.row?.standardCost}`}</span>
    </div>
  );
};
